import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { HTTPService, DataService, HelperService } from 'app/services';
import { config, defaultWorkFlows } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-customer-estimate',
  templateUrl: './customer-estimate.component.html',
  styleUrls: ['./customer-estimate.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerEstimateComponent implements OnInit {
  @Input('customerData')
  set customerData(data: any) {
    if (data) {
      this.customer = data;
      if (this.customer._id) {
        this._getCustomerEstimate(this.customer._id);
      } else {
        this.activeEstimates = [];
        this.archivedEstimates = [];
      }
    }
  }
  @Input() vehicles: any[] = [];
  @Input() isMultiLocationEnabled: boolean = false;
  @Input() shopsMap: any = {};

  fm: any = datetimeFormat;
  estBtnDisable: boolean = false;
  customer: any;
  customerEstimates = [];
  archivedEstimates: any[] = [];
  activeEstimates: any[] = [];
  confg = config;
  usd = currency.USD;
  defaultTitle: string = config.defaultTitle;
  estimate: any = {
    title: '',
    authorized: false,
    start: new Date(),
    end: null,
    orderStatus: config.estimate.defaultOrderStatus,
    notes: '',
    customerNotes: '',
    shopNotes: '',
    techs: [],
    customer: {},
    vehicle: {},
    tags: [],
    appointments: [],
    services: [],
    inspections: [],
    isPickupScheduled: false,
    pickupDate: null,
  };
  isProcessing: boolean = false;

  constructor(private httpService: HTTPService, private dataService: DataService, public helperService: HelperService) {}

  ngOnInit() {}

  _getCustomerEstimate(customerId) {
    this.isProcessing = true;
    this.activeEstimates = [];
    this.archivedEstimates = [];
    this.httpService.getCustomerEstimates(customerId).then(
      (estimates: any[]) => {
        this.isProcessing = false;
        if (estimates.length) {
          this.populateEstimates(estimates);
        } else {
          this.activeEstimates = [];
          this.archivedEstimates = [];
        }
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  populateEstimates(estimates) {
    for (let i = 0; i < estimates.length; i++) {
      const estimate = estimates[i];
      if (estimate.workFlowStatus.name === defaultWorkFlows.archive) {
        this.archivedEstimates.push(estimate);
      } else {
        this.activeEstimates.push(estimate);
      }
    }
  }

  openScheduleAppointmentModal() {
    this.dataService.sendData(
      this.dataService.typeDialog('add-appointment', 'upcoming-appointment', null, null, {
        _id: this.customer._id,
        fullName: this.customer.fullName,
      })
    );
  }

  openEstimate(estimate) {
    if (estimate._id) {
      this.helperService.openPageInNewExistingTab(`/estimate/${estimate._id}`, estimate._id);
    }
  }

  openEstimer() {
    // run if button not disabled
    if (!this.estBtnDisable) {
      // disable button
      this.estBtnDisable = true;
      this.estimate.title = this.customer.fullName;
      this.estimate.customer = {
        customerId: this.customer._id,
        fullName: this.customer.fullName,
        displayName: this.customer.fullNameQBO,
        isFleetCustomer: this.customer.isFleetCustomer,
        companyName: this.customer.companyName,
        email: this.customer.email,
        phone: this.customer.phone,
        phone2: this.customer.phone2,
        tags: this.customer.tags,
        notes: this.customer.notes,
      };

      // if (this.vehicles.length) {
      //   const [vehicle] = this.vehicles;
      //   this.estimate.vehicle = {
      //     vehicleId: vehicle,
      //     name: vehicle.name,
      //   };
      // }

      // Create Estimate
      this.httpService.createEstimates({ ...this.estimate, activity: [], browserSessionId: Date.now() }).then(
        (order: any) => {

          const queryParams: any = {
            browserSessionToken: order.restriction.token || '',
            checkPreferredLocation: order.checkPreferredLocation || false,
          };
          const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
          this.helperService.openPageInNewExistingTab(url, order._id);
          if (this.dataService.isGainSightPXEnabled) {
            const estimateCreated: any = {
              roCreationSource: 'Customer side-panel repair order tab',
              roNumber: order.code || '',
            };
      
            (<any>window).aptrinsic('track', 'RO Created', estimateCreated);
          }

          // enable button again
          this.estBtnDisable = false;
        },
        (err) => {
          this.helperService.showToaster('error', err);
          // enable button again
          this.estBtnDisable = false;
        }
      );
    } else {
    }
  }
}
